<nph-layout-profile-sidebar-block>
    <nph-layout-profile-sidebar-block-title>
        {{ 'module.profile.welcome' | transloco}}
    </nph-layout-profile-sidebar-block-title>

    <nph-layout-profile-sidebar-block-subtitle>
        {{ name }}
    </nph-layout-profile-sidebar-block-subtitle>

    <nph-layout-profile-sidebar-block-item icon="pi pi-user" (click)="onProfileClick()">
        <span class="mb-2 font-semibold">{{ 'module.profile.profile' | transloco}}</span>
        <p class="text-color-secondary m-0">{{ 'module.profile.profile_description' | transloco}}</p>
    </nph-layout-profile-sidebar-block-item>

    <nph-layout-profile-sidebar-block-item icon="pi pi-power-off" (click)="onSignOutClick()">
        <span class="mb-2 font-semibold">{{ 'module.profile.sign-out' | transloco}}</span>
        <p class="text-color-secondary m-0">{{ 'module.profile.sign-out-description' | transloco}}</p>
    </nph-layout-profile-sidebar-block-item>
</nph-layout-profile-sidebar-block>